import { Type, type Static } from "@sinclair/typebox";
import type { InvoiceDestination } from "./catalog-invoices.js";
const year = Type.Integer({ minimum: 2000, maximum: 2200 });
const uuid = Type.String({ format: "uuid" });
const selection = {
  managementYear: year,
  supplierId: uuid,
  destination: Type.Union([Type.Literal("job"), Type.Literal("structure")]),
  costCenterId: Type.Optional(uuid),
};
export const SupplierDestinationsQuerySchema = Type.Object(
  { managementYear: year },
  { additionalProperties: false },
);
export const SupplierDestinationPreviewSchema = Type.Object(selection, {
  additionalProperties: false,
});
export const SupplierDestinationConfirmSchema = Type.Object(
  {
    ...selection,
    confirmed: Type.Literal(true),
    expectedFingerprint: Type.String({ pattern: "^[a-f0-9]{64}$" }),
    operationId: uuid,
  },
  { additionalProperties: false },
);
export type SupplierDestinationPreviewInput = Static<
  typeof SupplierDestinationPreviewSchema
>;
export type SupplierDestinationConfirm = Static<
  typeof SupplierDestinationConfirmSchema
>;
export interface SupplierDestinationRule {
  destination: "job" | "structure";
  costCenterId: string | null;
  version: number;
}
export interface SupplierDestinationInvoice {
  id: string;
  invoiceNumber: string | null;
  date: string;
  netAmount: string;
  currency: string;
  destination: InvoiceDestination;
}
export interface SupplierDestinationSupplier {
  supplierId: string;
  supplier: string;
  invoiceCount: number;
  netAmount: string;
  excludedCurrencyCount: number;
  status: "pending" | "configured" | "known";
  currentDestination: "job" | "structure" | null;
  savedRule: SupplierDestinationRule | null;
  invoices: SupplierDestinationInvoice[];
}
export interface SupplierDestinationsPage {
  managementYear: number;
  companyId: string;
  suppliers: SupplierDestinationSupplier[];
  centers: { id: string; name: string }[];
}
export interface SupplierDestinationPreview {
  managementYear: number;
  supplierId: string;
  supplier: string;
  destination: "job" | "structure";
  costCenterId: string | null;
  invoiceCount: number;
  netAmount: string;
  excludedCurrencyCount: number;
  invoices: SupplierDestinationInvoice[];
  existingRule: SupplierDestinationRule | null;
  otherYears: number[];
  blockingIssues: string[];
  fingerprint: string;
}
export interface SupplierDestinationResult {
  id: string;
  replayed: boolean;
  preview: SupplierDestinationPreview;
}
